import { API_URL } from "./Config";
import { formatDate, formatDateForFiltering } from "./DateUtils";
import { PageResult, PageRequest } from "./Pagination";
import { EpaGridOrderByFetchParams } from "../leap-components/Grid/EpaGridProps";

export interface ILicenceSearchRow {
  licenceid: string;
  authorisationnumber: string;
  authorisationname: string;
  authorisationtype: string;
  organisation: string;
  finalauthorisationissueddate: string;
  county: string;
  status: string;
  openforsubmissions: string;
  openforobjections: string;
  pdduethisyear: string;
  sector: string;
}

export interface ILicenceSearchList extends PageResult {
  list: ILicenceSearchRow[];
}

export interface IAuthorisationType {
  name: string;
  value: string;
}

export interface IAuthorisationTypesList {
  list: IAuthorisationType[];
}

export interface ISector {
  name: string;
  value: string;
}

export interface ISectorsList {
  list: ISector[];
}

export interface ICounty {
  name: string;
  value: string;
}

export interface ICountyList {
  list: ICounty[];
}

export interface ILicenceStatus {
  name: string;
  value: string;
}

export interface ILicenceStatusesList {
  list: ILicenceStatus[];
}

export interface IBasicSearchFiltersProps {
  authorisationTypes: string[];
  sectorsList: ISectorsList;
}

export const YesNoAllFilterValues = ["Yes", "No"];

export async function GetAuthorisationTypesAsync(): Promise<IAuthorisationTypesList> {
  let url = `${API_URL}/Licence/searchtypesfilter`;

  if (process.env.REACT_APP_EPA_ENV === "localhost") {
    url = `${API_URL}/authorisation-types-filter`;
  }

  var response = await fetch(url);
  var body = <IAuthorisationTypesList>await response.json();
  body.list = body.list.map((item) => {
    return <IAuthorisationType>{
      name: item.name,
      value: item.value,
    };
  });
  return body;
}

export async function GetCountiesAsync(): Promise<ICountyList> {
  let url = `${API_URL}/Licence/searchcountyfilter`;

  if (process.env.REACT_APP_EPA_ENV === "localhost") {
    url = `${API_URL}/county-search-filter`;
  }

  var response = await fetch(url);
  var body = <ICountyList>await response.json();
  body.list = body.list.map((item) => {
    return <ICounty>{
      name: item.name,
      value: item.value,
    };
  });
  return body;
}

export async function GetSearchSectorsListAsync(): Promise<ISectorsList> {
  let url = `${API_URL}/Licence/searchsectorsfilter`;

  if (process.env.REACT_APP_EPA_ENV === "localhost") {
    url = `${API_URL}/sectors-search-filter`;
  }

  var response = await fetch(url);
  var body = <ISectorsList>await response.json();
  body.list = body.list.map((item) => {
    return <ISector>{
      name: item.name,
      value: item.value,
    };
  });
  return body;
}

export async function GetSearchStatusesListAsync(): Promise<ILicenceStatusesList> {
  let url = `${API_URL}/Licence/searchstatusfilter`;

  if (process.env.REACT_APP_EPA_ENV === "localhost") {
    url = `${API_URL}/status-search-filter`;
  }

  var response = await fetch(url);
  var body = <ILicenceStatusesList>await response.json();
  body.list = body.list.map((item) => {
    return <ILicenceStatus>{
      name: item.name,
      value: item.value,
    };
  });
  return body;
}

export const GetLicenceAdvancedSearchFetchUrl = (
  pageNo: number,
  recordsPerPage: number,
  searchText: string,
  filters: any,
  orderBy?: EpaGridOrderByFetchParams
) => {
  let params = `page=${pageNo}&per_page=${recordsPerPage}`;

  let filterParams = "";
  if (filters) {
    for (var i = 0; i < filters.length; i++) {
      var f = filters[i];
      let filterId = f.id;
      if (filterId === "authorisationtype") {
        filterId = "type_filter";
        filterParams += `&${filterId}=${f.value}`;
      } else if (filterId === "sector") {
        filterId = "sector_filter";
        filterParams += `&${filterId}=${f.value}`;
      } else if (filterId === "status") {
        filterId = "status_filter";
        filterParams += `&${filterId}=${f.value}`;
      } else if (filterId === "county") {
        filterId = "county_filter";
        filterParams += `&${filterId}=${f.value}`;
      } else if (filterId === "openforsubmissions") {
        filterId = "submssionsopen_filter";
        filterParams += `&${filterId}=${f.value}`;
      } else if (filterId === "openforobjections") {
        filterId = "objectionsopen_filter";
        filterParams += `&${filterId}=${f.value}`;
      } else if (filterId === "pdduethisyear") {
        filterId = "pdduethisyear_filter";
        filterParams += `&${filterId}=${f.value}`;
      } else {
        filterParams += `&${filterId}=${f.value}`;
      }
    }
  }

  if (searchText && searchText.length > 0) {
    filterParams += `&search_term=${encodeURIComponent(searchText)}`;
  }

  if (orderBy) {
    let orderByParam = "";
    switch (orderBy?.orderByName) {
      case "Number":
        orderByParam = "authorisationnumber";
        break;

      case "Name":
        orderByParam = "authorisationname";
        break;

      case "Final Authorisation Issued":
      default:
        orderByParam = "finalauthorisationissueddate";
    }

    params += `&order_by=${encodeURIComponent(orderByParam)}${
      orderBy.orderByAscending ? "" : "[desc]"
    }`;
  }

  let url = `${API_URL}/Licence/licencesearchlistfilters?${params}${filterParams}`;

  if (process.env.REACT_APP_EPA_ENV === "localhost") {
    url = `${API_URL}/licence-advanced-search`;
  }

  return url;
};
